import { ZigButton, ZigButtonProps, ZigTypography } from '@ui/index';
import { GoogleIcon } from '@ui/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/system';

export const GoogleButton = (props: ZigButtonProps) => (
  <ZigButton
    type={'button'}
    startIcon={<GoogleIcon />}
    endIcon={<></>}
    variant={'outlined'}
    size={'xlarge'}
    fullWidth
    sx={{
      justifyContent: 'space-between !important',
      '.MuiButton-startIcon': {
        marginLeft: '-14px',
      },
    }}
    {...props}
  />
);

export const OrSeparator = () => {
  const { t } = useTranslation('common');

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        gap: '20px',
        '& > div': {
          flex: 1,
          position: 'relative',
          top: '9px',
          borderTop: (theme) => `${theme.palette.neutral600} 0.5px solid`,
        },
        '& > span': {},
      }}
    >
      <Box component={'div'} />
      <ZigTypography variant={'body2'}>{t('common:or')}</ZigTypography>
      <Box component='div' />
    </Box>
  );
};
